// Notice.js

import React, {
    useEffect,
    useState
} from "react";


import api from "../../api/api";


import {
    Badge,
    Dropdown,
    List,
    Typography,
    Divider,
    Empty,
    Avatar,
} from "antd";


import {
    BellOutlined,
    CheckCircleOutlined,
} from "@ant-design/icons";



const {
    Text
} = Typography;




const Notice = () => {



    // ============================
    // Notifications State
    // ============================

    const [
        notifications,
        setNotifications
    ] = useState([]);



    const [
        unreadCount,
        setUnreadCount
    ] = useState(0);




    // ============================
    // Animation States
    // ============================

    const [
        clickedNotificationId,
        setClickedNotificationId
    ] = useState(null);



    const [
        hoveredId,
        setHoveredId
    ] = useState(null);




    // ============================
    // Responsive Mobile Detection
    // ============================

    const [
        isMobile,
        setIsMobile
    ] = useState(
        window.innerWidth <= 480
    );




    useEffect(()=>{


        const handleResize = ()=>{


            setIsMobile(
                window.innerWidth <= 480
            );


        };



        window.addEventListener(
            "resize",
            handleResize
        );



        return ()=>{


            window.removeEventListener(
                "resize",
                handleResize
            );


        };



    },[]);







    // ============================
    // Fetch Notifications
    // ============================


    const fetchNotifications = async()=>{


        try{


            const res = await api.get(
                "api/users/notifications/"
            );



            const sorted = [

                ...res.data

            ].sort(


                (a,b)=>

                new Date(b.created_at)
                -
                new Date(a.created_at)


            );



            setNotifications(
                sorted
            );



            setUnreadCount(

                sorted.filter(

                    item=>

                    !item.is_read

                ).length

            );



        }
        catch(error){


            console.error(

                "Notification loading error:",

                error

            );


        }



    };







    // ============================
    // Load Notifications
    // ============================


    useEffect(()=>{


        fetchNotifications();


    },[]);








    // ============================
    // Mark Notification As Read
    // ============================


    const markAsRead = async(id)=>{


        try{


            await api.post(

                `api/users/notifications/${id}/mark_as_read/`,

                {
                    is_read:true
                }

            );



            setNotifications(prev=>


                prev.map(item=>


                    item.id === id


                    ?


                    {

                        ...item,

                        is_read:true

                    }


                    :


                    item


                )


            );




            setUnreadCount(prev=>

                Math.max(

                    0,

                    prev - 1

                )

            );



        }
        catch(error){


            console.error(

                "Mark notification error:",

                error

            );


        }



    };








    // ============================
    // Notification Click Animation
    // ============================


    const handleNotificationClick = (id)=>{


        setClickedNotificationId(
            id
        );



        markAsRead(
            id
        );



        setTimeout(()=>{


            setClickedNotificationId(
                null
            );


        },500);



    };







    // ============================
    // Notification Dropdown Content
    // ============================


    const notificationContent = (



        <div



        style={{



            width: isMobile

            ?

            "calc(100vw - 32px)"

            :

            380,





            maxWidth:380,





            padding:

            isMobile

            ?

            12

            :

            18,





            borderRadius:22,





            background:

            "linear-gradient(145deg,#090909,#292929)",





            boxShadow:

            "0 20px 60px rgba(0,0,0,.55)",





            border:

            "1px solid #3f3f3f",





            marginLeft:

            isMobile

            ?

            16

            :

            0,





            marginRight:

            isMobile

            ?

            16

            :

            0,



        }}



        >





            {/* ============================
                Header
            ============================ */}



            <div



            style={{



                display:"flex",



                justifyContent:"space-between",



                alignItems:"center",



                gap:10



            }}



            >





                <Typography.Title



                level={5}



                style={{



                    color:"#fff",



                    margin:0,



                    fontWeight:800,



                    fontSize:

                    isMobile

                    ?

                    16

                    :

                    18



                }}



                >



                    🔔 Notifications



                </Typography.Title>







                <Badge



                count={unreadCount}



                overflowCount={99}



                style={{



                    background:"#f97316",



                    boxShadow:

                    "0 0 12px rgba(249,115,22,.6)"



                }}



                />




            </div>








            <Divider



            style={{



                borderColor:"#444"



            }}



            />









            {/* ============================
                Empty State
            ============================ */}



            {
                notifications.length === 0


                ?



                <Empty



                image={

                    Empty.PRESENTED_IMAGE_SIMPLE

                }



                description={



                    <span



                    style={{



                        color:"#aaa"



                    }}



                    >



                        No notifications



                    </span>



                }



                />




                :






                // ============================
                // Notification List
                // ============================


                <List



                dataSource={notifications}



                style={{



                    maxHeight:420,



                    overflowY:"auto",



                    paddingRight:5



                }}





                renderItem={(item)=>(




                    <List.Item





                    onMouseEnter={()=>



                        setHoveredId(

                            item.id

                        )



                    }





                    onMouseLeave={()=>



                        setHoveredId(null)



                    }





                    onClick={()=>



                        handleNotificationClick(

                            item.id

                        )



                    }





                    style={{





                        cursor:"pointer",





                        marginBottom:12,





                        padding:

                        isMobile

                        ?

                        10

                        :

                        14,





                        borderRadius:16,





                        background:

                        hoveredId === item.id





                        ?





                        "linear-gradient(135deg,#f97316,#111)"





                        :





                        item.is_read





                        ?





                        "#1f2937"





                        :





                        "linear-gradient(135deg,#064e3b,#111)",







                        border:





                        item.is_read





                        ?





                        "1px solid #444"





                        :





                        "1px solid #84cc16",







                        transform:





                        hoveredId === item.id ||





                        clickedNotificationId === item.id





                        ?





                        "translateY(-5px) scale(1.03)"





                        :





                        "scale(1)",







                        transition:

                        "all .35s ease",







                        boxShadow:





                        hoveredId === item.id





                        ?





                        "0 10px 30px rgba(249,115,22,.45)"





                        :





                        "none"





                    }}






                    >







                        <List.Item.Meta





                        avatar={





                            <Avatar





                            size={

                                isMobile

                                ?

                                38

                                :

                                46

                            }





                            style={{





                                background:





                                item.is_read





                                ?





                                "#374151"





                                :





                                "#f97316"





                            }}






                            icon={





                                item.is_read





                                ?





                                <CheckCircleOutlined />





                                :





                                <BellOutlined />





                            }





                            />





                        }





                        title={





                            <Text





                            style={{





                                color:"#fff",





                                fontWeight:700,





                                fontSize:

                                isMobile

                                ?

                                13

                                :

                                14,





                                display:"block",





                                wordBreak:

                                "break-word"





                            }}






                            >





                                {item.message}





                            </Text>





                        }







                        description={





                            <Text





                            style={{





                                color:"#d1d5db",





                                fontSize:

                                isMobile

                                ?

                                11

                                :

                                12





                            }}






                            >





                                {

                                    new Date(

                                        item.created_at

                                    )

                                    .toLocaleString()

                                }





                            </Text>





                        }







                        />







                    </List.Item>





                )}






                />



            }





        </div>



    );





    // ============================
    // Render Notification Bell
    // ============================


    return (




        <Dropdown



        dropdownRender={

            ()=>notificationContent

        }





        trigger={[

            "click"

        ]}






        placement={



            isMobile



            ?



            "bottom"



            :



            "bottomRight"



        }







        overlayStyle={{



            padding:0



        }}






        >






            <Badge



            count={unreadCount}



            offset={[

                0,

                5

            ]}





            style={{



                background:"#f97316",



                boxShadow:

                "0 0 15px rgba(249,115,22,.7)"



            }}



            >







                <BellOutlined





                style={{





                    fontSize:

                    isMobile

                    ?

                    24

                    :

                    26,





                    color:"#f97316",





                    cursor:"pointer",





                    transition:

                    "all .3s ease"





                }}







                onMouseEnter={(e)=>{





                    e.currentTarget.style.color =

                    "#84cc16";







                    e.currentTarget.style.transform =

                    "scale(1.15) rotate(15deg)";





                }}








                onMouseLeave={(e)=>{





                    e.currentTarget.style.color =

                    "#f97316";







                    e.currentTarget.style.transform =

                    "scale(1) rotate(0deg)";





                }}







                />







            </Badge>







        </Dropdown>





    );





};






export default Notice;